import api, { createApiService } from '../http/index'
import { IPoster, PostersAllRequest } from '../types/services-types/poster-types'

export default class PosterService {

    static apiPosterService = createApiService('/poster')


    static async Create(formData: FormData) {
        const response = await this.apiPosterService.post(`/create`, formData)
        return response.data
    }

    static async Get(id: number | string) {
        const response = await this.apiPosterService.get<IPoster>(`/${id}`)
        return response.data
    }

    static async GetAll(limit: string | number, page: string | number) {
        const response = await this.apiPosterService.get<PostersAllRequest>('/all', {
            params: {
                limit,
                page
            }
        })
        return response.data
    }

    static async GetImportantAll(limit: string | number, page: string | number) {
        const response = await this.apiPosterService.get<PostersAllRequest>('/important-all', {
            params: {
                limit,
                page
            }
        })
        return response.data
    }

    static async GetVacancyAll(limit: string | number, page: string | number) {
        const response = await this.apiPosterService.get<PostersAllRequest>('/vacancy-all', {
            params: {
                limit,
                page
            }
        })
        return response.data
    }

    static async Update(formData: FormData) {
        const response = await this.apiPosterService.post(`/update`, formData)
        return response.data
    }

    static async Delete(id: string | number) {
        const response = await this.apiPosterService.get(`/delete/${id}`)
        return response.data
    }
}